// Marka tek yerde.
//
// İsim HENÜZ SEÇİLMEDİ; "akış" geçici. Seçildiğinde değişecek yer burası ve
// sunucudaki `BRAND_NAME` — başka hiçbir dosyada marka metni yok.
//
// İşaret (mark) isimden bağımsız olarak tasarlandı: ürünün değişmeyen tek
// kuralını anlatıyor — hesap başına HER ZAMAN tek yayın. Halkanın bir yayı
// dolu, ortasında tek bir nokta var: "ölçülü bir pay, tek bir akış".
// Bu biçim arayüzde zaten yaşıyor (kalan süre halkası), yani logo ürünün
// kendi mekaniğinden çıkıyor, üstüne yapıştırılmış bir süs değil.

export const BRAND = {
  /** Görünen ad. Küçük harf yazımı bilinçli: sakin, iddiasız. */
  name: 'akış',
  /** Sekme başlığı ve paylaşım başlıkları. */
  title: 'Akış',
};

/**
 * Marka işareti. Tek renk, `currentColor` — koyu uygulamada açık, açık
 * zeminde koyu görünür. 16 px'te de okunur: dış halka + tek dolu yay + nokta.
 */
export function brandMark(size = 22): SVGSVGElement {
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  svg.setAttribute('fill', 'none');
  svg.setAttribute('aria-hidden', 'true');

  // Tek bir yay, açık uçlu. Soluk tam halka denendi ve 16 px'te yayla birleşip
  // düz bir daireye dönüştü; kaldırıldı. Açıklık işareti daireden ayırıyor.
  const arc = document.createElementNS(ns, 'path');
  arc.setAttribute('d', 'M18.9 17.4A8.5 8.5 0 1 0 12 20.5');
  arc.setAttribute('stroke', 'currentColor');
  arc.setAttribute('stroke-width', '2.2');
  arc.setAttribute('stroke-linecap', 'round');

  // Merkez: tek yayın.
  const dot = document.createElementNS(ns, 'circle');
  dot.setAttribute('cx', '12');
  dot.setAttribute('cy', '12');
  dot.setAttribute('r', '3.1');
  dot.setAttribute('fill', 'currentColor');

  svg.append(arc, dot);
  return svg;
}
